/**
 * ProfileSecurity.jsx — security questions, passkeys, and the
 * "Change password" action. Extracted Feb 26 2026.
 */
import React, { useState } from 'react';
import { Lock, KeyRound } from 'lucide-react';
import ProfileSubPage from '../components/ProfileSubPage';
import SecurityQuestionsSetup from '../components/SecurityQuestionsSetup';
import PasskeyManager from '../components/PasskeyManager';
import ChangePasswordDialog from '../components/ChangePasswordDialog';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const ProfileSecurity = () => {
  const [showChangePassword, setShowChangePassword] = useState(false);
  return (
    <ProfileSubPage title="Security" icon={Lock} accent="rose">
      <Card className="bg-slate-800/50 border-slate-700">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <KeyRound className="w-5 h-5 text-rose-400" /> Password
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Button
            onClick={() => setShowChangePassword(true)}
            variant="outline"
            className="w-full justify-start border-slate-600 text-white hover:bg-slate-700"
            data-testid="change-password-open"
          >
            Change Password
          </Button>
        </CardContent>
      </Card>
      <SecurityQuestionsSetup />
      <PasskeyManager />
      <ChangePasswordDialog open={showChangePassword} onOpenChange={setShowChangePassword} />
    </ProfileSubPage>
  );
};

export default ProfileSecurity;
